module.exports = __webpack_public_path__ + "assets/img/bj.d42d8b7c.png";